import axios from 'axios';
import {
  FETCHING_ALLOCATION_UNITS,
  FETCH_ALLOCATION_UNITS_SUCCESS,
  CREATING_ALLOCATION_UNIT,
  CREATE_ALLOCATION_UNIT_SUCCESS,
  RESET_ALLOCATION_UNIT,
  UPDATING_ALLOCATION_UNIT,
  UPDATE_ALLOCATION_UNIT_SUCCESS,
  DELETING_ALLOCATION_UNIT,
  DELETE_ALLOCATION_UNIT_SUCCESS,
  DELETE_ALLOCATION_UNIT_FAILED,
  RESET_DELETE_FAILED_FLAG,
  FETCHING_ALLOCATION_UNIT,
  FETCH_ALLOCATION_UNIT_SUCCESS,
  FETCH_ALL_ALLOCATION_UNITS_SUCCESS,
  FETCHING_ALL_ALLOCATION_UNITS,
  SELECT_COST_OBJ_ALLOCATION_UNIT
} from './AllocationUnitsConstants';

const fetchAllocationUnitsSuccess = (allocationUnits, pageState) => ({ type: FETCH_ALLOCATION_UNITS_SUCCESS, allocationUnits, pageState });
const fetchingAllocationUnits = pageStats => ({ type: FETCHING_ALLOCATION_UNITS, pageStats });
const fetchingAllAllocationUnits = () => ({ type: FETCHING_ALL_ALLOCATION_UNITS });
const creatingAllocationUnit = () => ({ type: CREATING_ALLOCATION_UNIT });
const createAllocationUnitSuccess = allocationUnit => ({ type: CREATE_ALLOCATION_UNIT_SUCCESS, allocationUnit });
const resetAllocationUnit = () => ({ type: RESET_ALLOCATION_UNIT });
const updatingAllocationUnit = () => ({ type: UPDATING_ALLOCATION_UNIT });
const updateAllocationUnitSuccess = allocationUnit => ({ type: UPDATE_ALLOCATION_UNIT_SUCCESS, allocationUnit });
const deletingAllocationUnit = () => ({ type: DELETING_ALLOCATION_UNIT });
const deleteAllocationUnitSuccess = allocationUnitId => ({ type: DELETE_ALLOCATION_UNIT_SUCCESS, allocationUnitId });
const deleteAllocationFailed = errorMessage => ({ type: DELETE_ALLOCATION_UNIT_FAILED, errorMessage });
const resetDeleteFailedFlag = () => ({ type: RESET_DELETE_FAILED_FLAG });
const fetchingAllocationUnit = () => ({ type: FETCHING_ALLOCATION_UNIT });
const fetchAllocationUnitSuccess = allocationUnit => ({ type: FETCH_ALLOCATION_UNIT_SUCCESS, allocationUnit });
const fetchAllAllocationUnitSuccess = allocationUnits => ({ type: FETCH_ALL_ALLOCATION_UNITS_SUCCESS, allocationUnits });
const selectCostObjAllocationUnit = (oldAllocationUnit, newAllocationUnit) => ({ type: SELECT_COST_OBJ_ALLOCATION_UNIT, oldAllocationUnit, newAllocationUnit });

const path = 'utm/v1/allocation-unit';

const fetchAllocationUnits = (page = 0, perPage = 10) => dispatch => {
  dispatch(fetchingAllocationUnits({ page, perPage }));
  axios.get(`${path}?page=${page}&perPage=${perPage}`)
    .then(allocationsResponse => {
      if (allocationsResponse.data.error) throw allocationsResponse.data.error;
      const { items, pageState } = allocationsResponse.data.data;
      if(items.length === 0 && pageState.page != 0){
        pageState.page = pageState.page -1;
        dispatch(fetchAllocationUnits(pageState.page, perPage));
      }
      else{
        dispatch(fetchAllocationUnitsSuccess(items, pageState));
      }      
    })
    .catch(error => { throw error; });
};

const fetchAllAllocationUnits = () => dispatch => {
  dispatch(fetchingAllAllocationUnits());
  axios.get(`${path}/all`)
    .then(response => {
      dispatch(fetchAllAllocationUnitSuccess(response.data.data));
    })
    .catch(error => { throw error; });
};

const createAllocationUnit = (allocationUnit, pageState) => dispatch => {
  dispatch(creatingAllocationUnit());
  axios.post(path, { ...allocationUnit })
    .then(() => {
      const { page, perPage } = pageState;
      dispatch(createAllocationUnitSuccess());
      dispatch(fetchAllocationUnits(page, perPage));
    })
    .catch(error => { throw error; });
};

const updateAllocationUnit = (allocationUnit, pageState) => dispatch => {
  dispatch(updatingAllocationUnit());
  axios.put(path, { ... allocationUnit })
    .then(() => {   
      const { page, perPage } = pageState; 
      dispatch(updateAllocationUnitSuccess());
      dispatch(fetchAllocationUnits(page, perPage));
    })
    .catch(error => { throw error; });
};

const fetchAllocationUnit = allocationUnitId => dispatch => {
  dispatch(fetchingAllocationUnit());
  axios.get(`${path}/${allocationUnitId}`)
    .then(response => {
      const allocation = response.data.data;
      dispatch(fetchAllocationUnitSuccess(allocation));
    })
    .catch(error => { throw error; });
};

const deleteAllocationUnit = (allocationUnitId, page, perPage) => dispatch => {
  dispatch(deletingAllocationUnit());
  axios.delete(`${path}/${allocationUnitId}`)
    .then(allocationResponse => {
      switch (allocationResponse.data.status) {
        case 200:
          dispatch(deleteAllocationUnitSuccess());
          dispatch(fetchAllocationUnits(page, perPage));
          break;
        default:
          dispatch(deleteAllocationFailed('This Allocation Unit is associated with a Cost Object and cannot be deleted.'));
          break;
      }
    })
    .catch(error => { throw error; });
};

export {
  fetchAllocationUnits,
  fetchAllAllocationUnits,
  createAllocationUnit,
  resetAllocationUnit,
  updateAllocationUnit,
  fetchAllocationUnit,
  deleteAllocationUnit,
  resetDeleteFailedFlag,
  selectCostObjAllocationUnit
};



// WEBPACK FOOTER //
// ./src/redux/allocationUnits/AllocationUnitsActions.js